var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticStyle:{"height":"100vh"},attrs:{"spinner-type":"grow","rounded":"true","variant":"dark","show":"","spinner-variant":"light"}})
}
var staticRenderFns = []

export { render, staticRenderFns }